import * as React from 'react';
import * as moment from 'moment';
import { connect } from 'react-redux';
import { Button, Dimmer, Grid, Loader, Header, Checkbox } from 'semantic-ui-react';
import GridView from "../../shared/component/grid";
import * as AppliedModifiersConstants from '../constant/applied_modifiers_constants';
import { prompt_settings } from '../constant/applied_modifiers_constants';
import DrawerComponent from '../../shared/component/drawer_component';
import { AlertConfirm } from '../../shared/component/alert_confirm_component';
import { Position } from '@blueprintjs/core';
import { get_applied_modifiers, get_applied_modifiers_payer, get_applied_modifiers_insurance_class, get_revenue_centers_and_proc_codes, get_state_locations, get_provider_types, save_applied_modifier } from '../action/applied_modifiers_action';
import AppliedModifiersAddEditComponent from './applied_modifiers_add_edit_component';
import { AppliedModifierFormData } from '../constant/applied_modifiers_constants';
import { custom_date_format, get_columns } from '../../shared/utility';
import { date_format } from '../../global_constants';
import * as ReportConstants from '../../reports/report_constants';
import { export_grid_data, print_grid_data, generateAuditDataEntryPayload } from "../../reports/util/export_print_utility";
import { log_error } from '../../shared/action/shared_action';
import * as global_constants from '../../global_constants';
import * as constants_actions from '../../admin/constants/action/constants_action';
import { toastr } from 'react-redux-toastr';

export class AppliedModifiersComponent extends React.Component<any, any> {

    _is_mounted = false;
    _display_applied_modifiers = [];
    _master_applied_modifiers_list = [];
    _raw_applied_modifiers_list = [];
    grid_header_height: number = 0;
    _grid_ref = { api: null };
    _proc_cod_list = [];
    _revenue_center_list = [];
    _primary_specialty_list = [];
    _provider_type_list = [];
    _state_location_list = [];
    _payer_list = [];
    _insurance_class_list = [];
    _to_charge_by_list = [];
    _to_charge_by_list_including_inactives = [];
    _initial_form_data = null;
    _current_form_data = null;
    _is_initializing = false;

    total_column_width: number = 0;
    reportId: string = '0';


    constructor(props) {
        super(props);
        this.state = {
            filter_options: {
                show_inactive: false,
                show_expired: false,
                show_future: false
            },
            loading: {
                applied_modifiers_list: true,
                criteria: true,
            },
            grid_rows_count: 0,
            grid_params: [],
            isDrawerOpen: false,
            editData: null,
            is_edit: false,
            showPrompt: false,
            hasUnsavedChanges: false
        };  
    }

    componentDidMount = () => {
        this._is_mounted = true;
        document.body.classList.add('admin-framework');
        this.initializeComponentData();
    }

    componentWillUnmount = () => {
        this._is_mounted = false;
        document.body.classList.remove('admin-framework');
        delete this._payer_list;
        delete this._insurance_class_list;
        delete this._revenue_center_list;
        delete this._proc_cod_list;
        delete this._provider_type_list;
        delete this._state_location_list;
        delete this._primary_specialty_list;
        delete this._provider_type_list;
        delete this._to_charge_by_list;
        delete this._to_charge_by_list_including_inactives;
    }

    //#region Initialize data and components
    initializeComponentData = async () => {
        try {
            await this.load_initial_api_data();
            await this.load_modifiers_list();
        } catch (error) {
            log_error(error);
        }
    }
    //#endregion

    //#region Loading state update
    get_updated_loader_state = (identifier, state) => {
        let loading = this.state.loading;
        loading[`${identifier}`] = state;
        return loading;
    }

    update_loader_display = (identifier, state) => {
        let loading = this.state.loading;
        loading[`${identifier}`] = state;
        this.setState({ loading });
    }

    display_loader = () => {
        let display_loader = false

        if (
            this._is_mounted == false ||
            this.state.loading.applied_modifiers_list == true
        ) {
            display_loader = true;
        }
        return display_loader;
    }
    //#endregion

    //#region Load and format data
    load_initial_api_data = async () => {
        if (this._is_mounted == false) return;
        let loading = true;

        try {
            const [payer_data, insurance_class_data, to_charge_by_list, primary_specialty_data, state_location_data, provider_type_data] = await Promise.all([
                this.load_payer_list(),
                this.load_insurance_class_list(),
                this.get_to_charge_by_list(),
                this.get_primary_specialty(),
                this.get_state_location_list(),
                this.get_provider_type_list()
            ]);

            this._payer_list = payer_data || [];
            this._insurance_class_list = insurance_class_data || [];
            this._to_charge_by_list = to_charge_by_list || [];
            if (to_charge_by_list && Array.isArray(to_charge_by_list[0].items)) {
                this._revenue_center_list = to_charge_by_list[0].items;
            } else {
                this._revenue_center_list = [];
            }
            if (to_charge_by_list && Array.isArray(to_charge_by_list[1].items)) {
                this._proc_cod_list = to_charge_by_list[1].items;
            } else {
                this._proc_cod_list = [];
            }
            this._primary_specialty_list = primary_specialty_data || [];
            this._state_location_list = state_location_data || [];
            this._provider_type_list =  provider_type_data || [];

            loading = false;
        } catch (error) {
            loading = false;
            log_error(error);
        }
    }

    load_payer_list = async () => {
        let payer_data = [];

        try {
            let response = await get_applied_modifiers_payer(this.props.user_login_details.user_data.data.token_details.access_token);
            if (response.data.data) {
                payer_data = response.data.data.map((val, index) => {
                    return {
                        value: val.payer_id,
                        name: val.display_name || val.payer_description || val.payer_code || `Payer ${index + 1}`,
                        on_hover_msg: ''
                    }
                });
                this._payer_list = payer_data;
            }
        } catch (error) {
            log_error(error)
        }

        return payer_data;
    }

    load_insurance_class_list = async () => {
        let insurance_class_data = [];

        try {
            const response = await get_applied_modifiers_insurance_class(this.props.user_login_details.user_data.data.token_details.access_token);
            if (response.data.data) {
                insurance_class_data = response.data.data.map((item, index) => {
                    return {
                        value: item.insurance_class_id,
                        name: item.display_text || item.insurance_class_description || item.insurance_class_code || `Insurance Class ${index + 1}`
                    }
                })
            }
        } catch (error) {
            log_error(error);
        }

        return insurance_class_data;
    }

    load_modifiers_list = async () => {
        if (this._is_mounted == false) return;
        let is_loading = true;
        this.update_loader_display(AppliedModifiersConstants.loading_identifier.applied_modifiers_list, is_loading);
        await get_applied_modifiers(this.props.user_login_details.user_data.data.token_details.access_token)
            .then(response => {
                if (response.data.data) {
                    this._raw_applied_modifiers_list = response.data.data;
                    let formatted_data = this.format_data(response.data.data);
                    this._master_applied_modifiers_list = formatted_data;
                    this.set_grid_display(formatted_data);
                    if (this._grid_ref && this._grid_ref.api) {
                        this._grid_ref.api.refreshCells({ force: true });
                    }
                    this._display_applied_modifiers = this.filter_data(this.state.filter_options);
                    this.setState({
                        grid_rows_count: formatted_data.length,
                    });
                }
                else {
                    this._master_applied_modifiers_list = [];
                    this._display_applied_modifiers = [];
                    this._raw_applied_modifiers_list = [];
                }
                is_loading = false;
            }, (error) => {
                is_loading = false;
                this._master_applied_modifiers_list = [];
                this._display_applied_modifiers = [];
                this._raw_applied_modifiers_list = [];
            })


        if (!is_loading) this.update_loader_display(AppliedModifiersConstants.loading_identifier.applied_modifiers_list, is_loading);
    }

    get_to_charge_by_list = async () => {
        let response: any = [];
        try {
            response = await get_revenue_centers_and_proc_codes(
                this.props.user_login_details.user_data.data.token_details.access_token,
                this.props.user_login_details.user_data.data.company_id
            );
        } catch (error) {
            log_error(error);
        }

        if (response && response.data && response.data.data) {
            this._to_charge_by_list_including_inactives = [{
                key: AppliedModifiersConstants.revenue_centers_and_proc_codes_tab.tab1.label,
                label: AppliedModifiersConstants.revenue_centers_and_proc_codes_tab.tab1.label,
                items: response.data.data.filter((row: any) =>
                    row.tab === AppliedModifiersConstants.revenue_centers_and_proc_codes_tab.tab1.tab)
                    .map(item => ({ value: item.id, label: item.description }))
            }, {
                key: AppliedModifiersConstants.revenue_centers_and_proc_codes_tab.tab2.label,
                label: AppliedModifiersConstants.revenue_centers_and_proc_codes_tab.tab2.label,
                items: response.data.data.filter((row: any) =>
                    row.tab === AppliedModifiersConstants.revenue_centers_and_proc_codes_tab.tab2.tab)
                    .map(item => ({ value: item.id, label: item.description }))
            }];

            return this._to_charge_by_list_including_inactives;
        } else {
            return [{
                key: AppliedModifiersConstants.revenue_centers_and_proc_codes_tab.tab1.label,
                label: AppliedModifiersConstants.revenue_centers_and_proc_codes_tab.tab1.label,
                items: []
            }, {
                key: AppliedModifiersConstants.revenue_centers_and_proc_codes_tab.tab2.label,
                label: AppliedModifiersConstants.revenue_centers_and_proc_codes_tab.tab2.label,
                items: []
            }];
        }
    }

    get_primary_specialty = async () => {
        let primary_specialties = [];
        try {
            const url = `${global_constants.end_points.provider_type_url.primary_speciality}`;
            const response = await constants_actions.get_data(this.props.user_login_details.user_data.data.token_details.access_token, url);
            if (response.data.data) {
                primary_specialties = response.data.data.map((val, index) => {
                    return {
                        value: val.specialty_id,
                        name: `${val.specialty_code} - ${val.specialty_desc}`
                    }
                })
            }
        } catch (error) {
            log_error(error);
        }
        return primary_specialties;
    }

    get_state_location_list = async () => {
        let primary_specialties = [];
        try {
            const response = await get_state_locations(this.props.user_login_details.user_data.data.token_details.access_token);
            if (response.data.data) {
                primary_specialties = response.data.data.map((val, index) => {
                    return {
                        value: val.id,
                        name: `${val.code} - ${val.description}`
                    }
                })
            }
        } catch (error) {
            log_error(error);
        }
        return primary_specialties;
    }

    get_provider_type_list = async () => {
        let provider_types = [];
        try {
            const response = await get_provider_types(this.props.user_login_details.user_data.data.token_details.access_token);
            if (response.data.data) {
                provider_types = response.data.data;
            }
        } catch (error) {
            log_error(error);
        }
        return provider_types;
    }
    //#endregion

    format_data = (raw_data) => {
        var data_list = [];
        var item = null;

        raw_data.map((data_item) => {
            let payers = [];
            let ins_classes = [];
            let payers_names = [];
            let ins_classes_names = [];
            let proc_codes = [];
            let state_locations = [];
            let revenue_centers = [];
            let provider_types = [];
            let primary_specialties = [];
            let proc_codes_names = [];
            let revenue_centers_names = [];
            let provider_types_names = [];
            let primary_specialty_names = [];
            let state_locations_names = [];

            let excluded = (data_item.claim_processing_criteria.claim_processing_criteria_id == AppliedModifiersConstants.criteria_type.payer_exclude_insurance_classes);
            if (data_item.claim_processing_criteria != null) {
                payers = data_item.claim_processing_criteria_source_details.filter(insClass => { return insClass.claim_processing_criteria_source_type_id === AppliedModifiersConstants.criteria_source_type.payer });
                ins_classes = data_item.claim_processing_criteria_source_details.filter(payer => { return payer.claim_processing_criteria_source_type_id === AppliedModifiersConstants.criteria_source_type.insurance_class });
                proc_codes = data_item.claim_processing_criteria_source_details.filter(payer => { return payer.claim_processing_criteria_source_type_id === AppliedModifiersConstants.criteria_source_type.procedure_code });
                state_locations = data_item.claim_processing_criteria_source_details.filter(payer => { return payer.claim_processing_criteria_source_type_id === AppliedModifiersConstants.criteria_source_type.location });
                revenue_centers = data_item.claim_processing_criteria_source_details.filter(payer => { return payer.claim_processing_criteria_source_type_id === AppliedModifiersConstants.criteria_source_type.revenue_center });
                provider_types = data_item.claim_processing_criteria_source_details.filter(payer => { return payer.claim_processing_criteria_source_type_id === AppliedModifiersConstants.criteria_source_type.provider_type });
                primary_specialties = data_item.claim_processing_criteria_source_details.filter(payer => { return payer.claim_processing_criteria_source_type_id === AppliedModifiersConstants.criteria_source_type.primary_specialty });

                if (payers.length > 0 ) {
                    let payers_ids = payers.map(ids => ids.claim_processing_criteria_source_data_id);
                    payers_names = this._payer_list.filter(payerNames => { return payers_ids.indexOf(payerNames.value) > -1 }).map(item => item.name);
                }
                if (ins_classes.length > 0 ) {
                    let ins_class_ids = ins_classes.map(ids => ids.claim_processing_criteria_source_data_id);
                    ins_classes_names = this._insurance_class_list.filter(insClass => { return ins_class_ids.indexOf(insClass.value) > -1 }).map(item => item.name);
                }
                if (proc_codes.length > 0 ) {
                    let proc_code_ids = proc_codes.map(ids => ids.claim_processing_criteria_source_data_id);
                    proc_codes_names = this._proc_cod_list.filter(procCode => { return proc_code_ids.indexOf(procCode.value) > -1 }).map(item => item.label);
                }
                if (revenue_centers.length > 0 ) {
                    let revenue_center_ids = revenue_centers.map(ids => ids.claim_processing_criteria_source_data_id);
                    revenue_centers_names = this._revenue_center_list.filter(revCenter => { return revenue_center_ids.indexOf(revCenter.value) > -1 }).map(item => item.label);
                }
                if (provider_types.length > 0 ) {
                    let provider_type_ids = provider_types.map(ids => ids.claim_processing_criteria_source_data_id);
                    provider_types_names = this._provider_type_list.filter(providerType => { return provider_type_ids.indexOf(providerType.id) > -1 }).map(item => item.name);
                }
                if (primary_specialties.length > 0 ) {
                    let primary_specialty_ids = primary_specialties.map(ids => ids.claim_processing_criteria_source_data_id);
                    primary_specialty_names = this._primary_specialty_list.filter(primarySpecialty => { return primary_specialty_ids.indexOf(primarySpecialty.value) > -1 }).map(item => item.name);
                }
                if (state_locations.length > 0 ) {
                    let state_location_ids = state_locations.map(ids => ids.claim_processing_criteria_source_data_id);
                    state_locations_names = this._state_location_list.filter(stateLocation => { return state_location_ids.indexOf(stateLocation.value) > -1 }).map(item => item.name);
                }
            }
            item = {
                claim_processing_rule_id: data_item.claim_processing_rule_id,
                claim_processing_rule_name: data_item.claim_processing_rule_name,
                modifier: data_item.applied_modifier == null ? '' : data_item.applied_modifier.proc_mod_code,
                status: data_item.is_active ? 'Active' : 'Inactive',
                last_updated_date_time: custom_date_format(data_item.last_updated, date_format.date_time_without_sec_format),
                last_updated_user: data_item.last_updated_user,
                is_active: data_item.is_active,
                claim_processing_criteria_source_details: data_item.claim_processing_criteria_source_details,
                claim_processing_criteria: data_item.claim_processing_criteria,
                start_date: data_item.start_date == null ? null : custom_date_format(data_item.start_date, date_format["mm/dd/yyyy"]),
                end_date: data_item.end_date == null ? null : custom_date_format(data_item.end_date, date_format["mm/dd/yyyy"]),
                provider_type: provider_types.length > 0 && provider_types_names.length > 0 ? provider_types_names[0] : ''
            };

            // Set qualifying criteria counts and content
            this.setQualifyingCriteriaData(item, data_item, {
                payers,
                ins_classes,
                proc_codes,
                state_locations,
                revenue_centers,
                primary_specialties,
                payers_names,
                ins_classes_names,
                excluded,
                proc_codes_names,
                revenue_centers_names,
                state_locations_names,
                primary_specialty_names
            });

            data_list.push(item);
        });
        return data_list;
    }

    setQualifyingCriteriaData = (item, data_item, criteriaData) => {
        if (data_item.claim_processing_criteria == null) {
            this.setEmptyQualifyingCriteria(item);
            return;
        }

        const {
            payers = [],
            ins_classes = [],
            proc_codes = [],
            state_locations = [],
            revenue_centers = [],
            primary_specialties = [],
            payers_names = [],
            ins_classes_names = [],
            excluded = false,
            proc_codes_names = [],
            revenue_centers_names = [],
            state_locations_names = [],
            primary_specialty_names = []
        } = criteriaData;

        item.qualifying_criteria_payer = this.formatCriteriaCount(payers.length, 'selected');
        item.qualifying_criteria_insurance_class = this.formatCriteriaCount(
            ins_classes.length,
            excluded ? 'excluded' : 'selected'
        );
        item.qualifying_criteria_procedure_codes = this.formatCriteriaCount(proc_codes.length, 'selected');
        item.qualifying_criteria_location = this.formatCriteriaCount(state_locations.length, 'selected');
        item.qualifying_criteria_revenue_center = this.formatCriteriaCount(revenue_centers.length, 'selected');
        item.qualifying_criteria_primary_specialty = this.formatCriteriaCount(primary_specialties.length, 'selected');

        // Tooltips content when available
        item.qualifying_criteria_payer_content = this.format_names_content(payers_names);
        item.qualifying_criteria_insurance_class_content = this.format_names_content(ins_classes_names);
        item.qualifying_criteria_procedure_codes_content = this.format_names_content(proc_codes_names);
        item.qualifying_criteria_revenue_center_content = this.format_names_content(revenue_centers_names);
        item.qualifying_criteria_location_content = this.format_names_content(state_locations_names);
        item.qualifying_criteria_primary_specialty_content = this.format_names_content(primary_specialty_names);
    }

    formatCriteriaCount = (count, suffix) => {
        return count > 0 ? `${count} ${suffix}` : '';
    }

    setEmptyQualifyingCriteria = (item) => {
        item.qualifying_criteria_payer = '';
        item.qualifying_criteria_insurance_class = '';
        item.qualifying_criteria_procedure_codes = '';
        item.qualifying_criteria_location = '';
        item.qualifying_criteria_revenue_center = '';
        item.qualifying_criteria_provider_type = '';
        item.qualifying_criteria_primary_specialty = '';
        item.qualifying_criteria_payer_content = '';
        item.qualifying_criteria_insurance_class_content = '';
        item.qualifying_criteria_procedure_codes_content = '';
        item.qualifying_criteria_revenue_center_content = '';
        item.qualifying_criteria_location_content = '';
        item.qualifying_criteria_provider_type_content = '';
        item.qualifying_criteria_primary_specialty_content = '';
    }

    format_names_content = (names) => {
        let content = (names.length > 0 ? names.join(', ') : '');
        return content;
    }

    set_grid_display = (display_data) => {
        const grid_height = get_columns(
            display_data,
            AppliedModifiersConstants.grid_settings_criteria_column.column_defs
        );
        this.total_column_width = grid_height.total_column_width;
        this.grid_header_height = grid_height.header_height;
    }

    filter_data = (filter_options) => {
        let filtered_list = [];
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        filtered_list = this._master_applied_modifiers_list.filter(item => {
            const isCurrentlyActive = new Date(item.start_date) <= today &&
                                    (item.end_date == null || new Date(item.end_date) >= today);
            const isExpired = item.end_date && new Date(item.end_date) < today;
            const isFuture = new Date(item.start_date) > today;
            const isActiveStatus = filter_options.show_inactive ? true : item.is_active === true;
            const shouldIncludeByDate = isCurrentlyActive ||
                                      (isExpired && filter_options.show_expired) ||
                                      (isFuture && filter_options.show_future);

            return shouldIncludeByDate && isActiveStatus;
        });

        return filtered_list;
    }

    //#region Event Handling
    update_filter_options = (event, filter_type) => {
        let filter_options = this.state.filter_options;
        if (filter_options[`${filter_type}`] != undefined) {
            filter_options[`${filter_type}`] = event.target.checked
        }

        this.update_loader_display(AppliedModifiersConstants.loading_identifier.applied_modifiers_list, true);

        this._display_applied_modifiers = this.filter_data(filter_options);

        let loading = this.get_updated_loader_state(AppliedModifiersConstants.loading_identifier.applied_modifiers_list, false);

        this.setState({
            loading,
            filter_options: filter_options
        });
    }

    new_modifier_handler = () => {
        this.setState({ editData: null }); // Clear edit data for new modifier
        // Reset form data tracking for new modifier
        this._initial_form_data = null;
        this._current_form_data = null;
        this._is_initializing = false; // Not initializing for new modifier, track changes immediately
        this.setState({ hasUnsavedChanges: false });
        this.handleDrawerOpen();
    };

    on_row_clicked = (e) => {
        const [modifier_data] = this._raw_applied_modifiers_list.filter(x => x.claim_processing_rule_id == e.data.claim_processing_rule_id);
        if (modifier_data) {
            // Deep clone and transform backend DTO to form data structure
            const clonedData = JSON.parse(JSON.stringify(modifier_data));
            const transformedData: any = AppliedModifiersConstants.transformBackendDtoToFormData(clonedData);
            // Attach the original claim_processing_rule_id for editing
            transformedData.claim_processing_rule_id = modifier_data.claim_processing_rule_id;
            this.handleEditModifier(transformedData);
        }
    };

    /**
     * Handle save modifier
     * @param data - AppliedModifierFormData object containing:
     *   - setting_name: string - Unique setting name
     *   - active_status: boolean - Whether the modifier is active
     *   - modifier: string - Modifier code
     *   - to_charge_by: ChargeByItem[] - Array of selected charge items with:
     *     - label: string - Selected item from the dropdown
     *     - tabId: ChargeByTabId - Tab id from the dropdown (RevenueCenter or ProcedureCode)
     *     - value: number - Id from the selected entity (Revenue Center or Procedure code)
     */
    handleSaveModifier = async (data: AppliedModifierFormData) => {
        try {
            // Transform frontend data to backend DTO structure
            const backendDto = AppliedModifiersConstants.transformFormDataToBackendDto(data, (this.state.editData && this.state.editData.claim_processing_rule_id) || 0);
            
            // Call the save API
            const response = await save_applied_modifier(
                this.props.user_login_details.user_data.data.token_details.access_token,
                backendDto
            );
            
            if (response.data && response.data.status == 1) {
                // Reset unsaved changes state and close drawer after successful save
                this._is_initializing = false; // Reset initialization flag
                this.setState({ 
                    hasUnsavedChanges: false, 
                    isDrawerOpen: false 
                });

                toastr.success('', AppliedModifiersConstants.messages.save_success_msg);
                
                // Reload the modifiers list
                this.load_modifiers_list();
            } else {
                // Handle error
                log_error(`${AppliedModifiersConstants.messages.save_error_msg}: ${response.data && response.data.messages}`);
                toastr.error('', AppliedModifiersConstants.messages.save_error_msg);
            }
        } catch (error) {
            log_error(`${AppliedModifiersConstants.messages.save_error_msg}: ${error}`);
            toastr.error('', AppliedModifiersConstants.messages.save_error_msg);
        }
    };

    on_export_button = () => {
        let title = this.set_title("\n");
        let page_name = AppliedModifiersConstants.page_title.name;
        page_name = page_name.replace(/<br>/g, "");
        export_grid_data(this._grid_ref, title, page_name);
        this.saveReportEventAction(ReportConstants.ReportEventAction.Export);
    };

    on_print_button = () => {
        let title = this.set_title("<br>");
        let btnPrintId = AppliedModifiersConstants.print_button.id;
        let page_name = AppliedModifiersConstants.page_title.name;
        print_grid_data(this._grid_ref, title, page_name, btnPrintId);
        this.saveReportEventAction(ReportConstants.ReportEventAction.Print);
    };

    //Used to create the title for export and print.
    set_title = separator => {
        let company_name = this.props.user_login_details.user_data.data.company_name;
        let current_date = moment(new Date()).format('MM/DD/YYYY') + ' ' + moment(new Date()).format('hh:mm:ss A');
        let title = AppliedModifiersConstants.page_title.name;
        let row_count = this._grid_ref.api.getModel().getRowCount();
        title =
            title.replace(/<br>/g, separator) +
            separator +
            company_name +
            separator +
            current_date +
            separator +
            (row_count == 1
                ? row_count + ' record'
                : row_count + ' records') +
            separator +
            separator;
        return title;
    };

    private saveReportEventAction = (eventActionId: number) => {
        const accessToken = this.props.user_login_details.user_data.data.token_details.access_token;
        const { user_id, company_id } = this.props.user_login_details.user_data.data;

        const payload: ReportConstants.IPayloadForBillingAudit = {
            reportId: this.reportId,
            contextTitle: `${AppliedModifiersConstants.page_title.name} - ${ReportConstants.ReportEventAction[eventActionId]}`,
            eventActionId: eventActionId,
            userId: Number(user_id),
            companyId: Number(company_id),
            entityTypeId: ReportConstants.ReportEntityTypeId.C_PROCEDURE_MODIFIER,
            data: { Records: this._display_applied_modifiers.length }
        }

        const reqBody = generateAuditDataEntryPayload(payload);

        ReportConstants.saveAuditPrintExport(reqBody, accessToken);
    }
    //#endregion Event Handling

    //#region grid ref
    get_grid_ref = grid_params => {
        this._grid_ref = grid_params;
        this.setState({
            grid_params,
            grid_rows_count: grid_params.api.getModel().getRowCount()
        });
        var grid_width = document.getElementsByClassName('admin-wrapper')[0].clientWidth;
        if (this.total_column_width > grid_width) {
            AppliedModifiersConstants.grid_settings_criteria_column.column_defs.filter(item => {
                grid_params.columnApi.setColumnWidth(item.field, item.width, false);
            });
        }
    };
    //#endregion

    //#region drawer region
    private handleDrawerClose = () => {
        if (this.state.hasUnsavedChanges) {
            this.setState({ showPrompt: true });
        } else {
            this._is_initializing = false; // Reset initialization flag
            this.setState({ isDrawerOpen: false });
        }
    }

    private handleDrawerOpen = () => {
        this.setState({ isDrawerOpen: true });
    }

    // Handle when drawer is opened for editing
    private handleEditModifier = (editData: any) => {
        this.setState({ editData });
        // Reset form data tracking for edit
        this._initial_form_data = null;
        this._current_form_data = null;
        this._is_initializing = true; // Flag to prevent tracking during initialization
        this.setState({ hasUnsavedChanges: false });
        this.handleDrawerOpen();
        
        // Allow form to fully initialize before tracking changes (in edit mode)
        setTimeout(() => {
            this._is_initializing = false;
        }, 250);
    }

    // Handle when form data is first loaded
    private handleFormDataInitialized = (formData) => {
        this.initializeFormData(formData);
    }

    // Handle prompt dialog actions
    private handlePromptConfirm = () => {
        this._is_initializing = false; // Reset initialization flag
        this.setState({ 
            showPrompt: false, 
            hasUnsavedChanges: false, 
            isDrawerOpen: false 
        });
    }

    private handlePromptCancel = () => {
        this.setState({ showPrompt: false });
    }

    // Normalize form data for comparison (treat equivalent values as equal)
    // Normalize form data for comparison - strips out auto-populated fields that don't represent user changes
    private normalizeForComparison = (formData) => {
        const normalized = JSON.parse(JSON.stringify(formData));
        
        // Normalize to_charge_by: only compare value and tabId, ignore label (auto-populated from dropdown)
        if (normalized.to_charge_by && Array.isArray(normalized.to_charge_by)) {
            normalized.to_charge_by = normalized.to_charge_by.map(item => ({
                value: item.value,
                tabId: item.tabId
            })).sort((a, b) => {
                // Sort by tabId first, then by value for consistent comparison
                if (a.tabId !== b.tabId) return a.tabId - b.tabId;
                return a.value - b.value;
            });
        }
        
        return normalized;
    }

    // Track form data changes
    private handleFormDataChange = (formData) => {
        // During initialization phase (edit mode), capture initial data but don't compare yet
        if (this._is_initializing) {
            if (!this._initial_form_data) {
                // Capture the initial form data during initialization
                this._initial_form_data = JSON.parse(JSON.stringify(formData));
                this._current_form_data = formData;
            }
            return;
        }
        
        if (!this._initial_form_data) {
            // First time - initialize the form data
            this.initializeFormData(formData);
        } else {
            // Subsequent updates - track changes
            this._current_form_data = formData;
            
            if (this._initial_form_data && this._current_form_data) {
                // Normalize both before comparison to ignore auto-populated fields
                const normalizedInitial = this.normalizeForComparison(this._initial_form_data);
                const normalizedCurrent = this.normalizeForComparison(this._current_form_data);
                
                const hasChanges = JSON.stringify(normalizedInitial) !== JSON.stringify(normalizedCurrent);
                
                // Only update state if the value actually changed to prevent unnecessary re-renders
                if (this.state.hasUnsavedChanges !== hasChanges) {
                    this.setState({ hasUnsavedChanges: hasChanges });
                }
            }
        }
    }

    // Initialize form data tracking
    private initializeFormData = (formData) => {
        this._initial_form_data = JSON.parse(JSON.stringify(formData));
        this._current_form_data = formData;
        this.setState({ hasUnsavedChanges: false });
    }
    //#endregion
    
    get_render_contents = () => {
        let render_contents =
            <React.Fragment>
                <Grid style={{ marginTop: 0, marginBottom: 0 }}>
                    <Grid.Column mobile={4} tablet={8} computer={8} style={{ textAlign: 'left' }} className="applied_modifiers_filters">
                        <Checkbox id={AppliedModifiersConstants.filter_options.show_inactive.settings.id}
                            label={AppliedModifiersConstants.filter_options.show_inactive.settings.name}
                            checked={this.state.filter_options.show_inactive}
                            onChange={(e) => this.update_filter_options(e, AppliedModifiersConstants.filter_options.show_inactive.type)}
                        />
                        <Checkbox id={AppliedModifiersConstants.filter_options.show_expired.settings.id}
                            label={AppliedModifiersConstants.filter_options.show_expired.settings.name}
                            checked={this.state.filter_options.show_expired}
                            onChange={(e) => this.update_filter_options(e, AppliedModifiersConstants.filter_options.show_expired.type)}
                        />
                        <Checkbox id={AppliedModifiersConstants.filter_options.show_future.settings.id}
                            label={AppliedModifiersConstants.filter_options.show_future.settings.name}
                            checked={this.state.filter_options.show_future}
                            onChange={(e) => this.update_filter_options(e, AppliedModifiersConstants.filter_options.show_future.type)}
                        />
                    </Grid.Column>
                    <Grid.Column mobile={4} tablet={8} computer={8} style={{ textAlign: 'right' }}>
                        <Button id={AppliedModifiersConstants.new_button.id} onClick={() => this.new_modifier_handler()} data-testid='applied-modifiers-new-button'>
                            {AppliedModifiersConstants.new_button.name}
                        </Button>
                    </Grid.Column>
                   
                </Grid>
            </React.Fragment>;

        return render_contents;
    }

    get_drawer_component = () => {
        let render_contents =
            <React.Fragment>
                <Grid style={{ marginTop: 0, marginBottom: 0 }}>
                    <Grid.Column computer={16} textAlign="right" className="applied_modifiers_drawer_wrapper">

                        <DrawerComponent
                            key={this.props.key_id}
                            canOutsideClickClose={true}
                            canEscapeKeyClose={false}
                            isOpen={this.state.isDrawerOpen}
                            className="ext-bp-drawer applied_modifiers_drawer"
                            handleDrawerClose={this.handleDrawerClose}
                            position={Position.RIGHT}
                            title=""
                            isCloseButtonShown={true}
                            innerContent={this.get_drawer_inner_content()}
                            size="40%"
                            disableAutoClose={true}
                            data-testid='applied-modifiers-drawer'
                            updateHandlerCallback={this.initializeComponentData}
                        />
                    </Grid.Column>
                </Grid>
            </React.Fragment>;

        return render_contents;
    }

    get_drawer_inner_content = () => {
        return (
            <AppliedModifiersAddEditComponent
                onClose={this.handleDrawerClose}
                onSave={this.handleSaveModifier}
                editData={this.state.editData}
                updateHandlerCallback={this.handleFormDataChange}
                data-testid='applied-modifiers-add-edit-component'
                toChargeByList={this._to_charge_by_list_including_inactives}
                primarySpecialtyList={this._primary_specialty_list}
                payerList={this._payer_list}
                insuranceClassList={this._insurance_class_list}
            />
        );
    };

    render() {
        let show_loader = this.display_loader();

        return (
            <div className='admin-wrapper'>
                <Dimmer active={show_loader}>
                    <Loader size='massive'>Loading</Loader>
                </Dimmer>

                <Grid className='headerGrid' style={{ marginTop: 10, marginBottom: 10, marginRight: 2 }}>
                    <Grid.Column mobile={4} tablet={8} computer={16}>
                        <Header as='h3' textAlign="left">{AppliedModifiersConstants.page_title.name}</Header>
                    </Grid.Column>
                </Grid>

                <div id='admin-scrollable-area' className='wrapper' style={{ flex: 1 }}>
                    <div className='patient-search-form patient_search_bottom_padding' id='search-criteria-container'>
                        {this.get_render_contents()}
                    </div>

                    {!show_loader && (
                        <GridView
                            id={AppliedModifiersConstants.grid_settings_criteria_column.grid_id}
                            row={this._display_applied_modifiers}
                            column={AppliedModifiersConstants.grid_settings_criteria_column.column_defs}
                            style={{ height: '100%' }}
                            wrapperStyle={{ width: '100%', height: '100%', display: 'flex'}}
                            enableColResize={true}
                            gridAutoRowHeight={true}
                            onCellClicked={this.on_row_clicked}
                            selectionType={'single'}
                            headerHeight={this.grid_header_height}
                            get_grid_ref={this.get_grid_ref}
                            emptyMessage={AppliedModifiersConstants.grid_settings_criteria_column.no_records_found_message}
                        />
                    )}
                </div>

                <div className='sixteen wide computer sixteen wide mobile sixteen wide tablet column footer-area' id='applicationFooterSticky'>
                    <Grid textAlign='right' style={{ marginTop: 0.5, marginBottom: 0.5 }}>
                        <Grid.Column computer={16} textAlign='right'>
                            <Button id={AppliedModifiersConstants.export_button.id} type='submit' onClick={() => this.on_export_button()} basic>
                                {AppliedModifiersConstants.export_button.name}
                            </Button>
                            <Button id={AppliedModifiersConstants.print_button.id} type='submit' onClick={() => this.on_print_button()} primary>
                                {AppliedModifiersConstants.print_button.name}
                            </Button>
                        </Grid.Column>
                    </Grid>
                </div>

                {!show_loader && this.state.isDrawerOpen && this.get_drawer_component()}
                
                {/* Prompt Dialog for Unsaved Changes */}
                <AlertConfirm
                    open={this.state.showPrompt}
                    close={this.handlePromptCancel}
                    cancel={this.handlePromptCancel}
                    confirm={this.handlePromptConfirm}
                    message={prompt_settings.message}
                    title={prompt_settings.unsaved_changes}
                    labelYes={prompt_settings.continue}
                    data-testid='applied-modifiers-unsaved-changes-alert-confirm-component'
                />
            </div>
        );
    }
}

//Get user and login details from store.
const mapStateToProps = state => {
    return {
        user_login_details: state.user_login_details,
    };
};

export default connect(mapStateToProps)(AppliedModifiersComponent);
